import { Box } from '@material-ui/core';
import React from 'react';

const ResultsContainer: React.FC = ({ children }) => {
  return <Box padding={6}>{children}</Box>;
};

export default ResultsContainer;
